import { render, staticRenderFns } from "./PaywallPreview.vue?vue&type=template&id=1942f615&scoped=true"
import script from "./PaywallPreview.vue?vue&type=script&lang=js"
export * from "./PaywallPreview.vue?vue&type=script&lang=js"
import style0 from "./PaywallPreview.vue?vue&type=style&index=0&id=1942f615&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1942f615",
  null
  
)

export default component.exports